import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {
    ProductDescriptionModel,
    ProductLogicsBrowserList,
    ProductLogicsCreatingForm,
    ProductLogicsMainDependenciesList
} from '../../../model/model';
import {ProductsDataService} from '../../../services/products.data.service';
import {finalize} from 'rxjs/operators';
import {TableColumnDef} from '../../../../../shared/tables/table-column-def';
import {SnackbarService} from '../../../../../core/services';

@Component({
    selector: 'product-logics-modal',
    templateUrl: './product-logics-modal.component.html',
    styleUrls: []
})
export class ProductLogicsModalComponent implements OnInit {
    products: ProductLogicsMainDependenciesList[] = [];
    product: ProductDescriptionModel = null;
    originProducts: ProductLogicsMainDependenciesList[] = [];
    startEdition: boolean = false;

    tableId: string;
    columnsData: TableColumnDef[];

    unselectTableId: string;
    unselectColumnsData: TableColumnDef[];

    constructor(
        public dialogRef: MatDialogRef<ProductLogicsModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            products: ProductLogicsMainDependenciesList[],
            product: ProductDescriptionModel
        },
        public dataService: ProductsDataService,
        public snackBar: SnackbarService,
    ) {
        this.products = data.products;
        this.product = data.product;
        // if we unselect product that has been set as dependent (on backend) then
        // it would be blocked, because IsDependent: false
        // original product list helps us check if product's current dependent state
        // without synchronizing each add and delete action in tables with backend
        this.originProducts = data.products;
    }

    ngOnInit() {
        const tableInfo = ProductLogicsBrowserList.tableInfo();
        this.tableId = tableInfo.tableId;
        this.columnsData = tableInfo.columns;

        const unselectTableInfo = ProductLogicsMainDependenciesList.unSelectTableInfo();
        this.unselectTableId = unselectTableInfo.tableId;
        this.unselectColumnsData = unselectTableInfo.columns;
    }

    public addNewRow(product: any) {
        if (!this.isAlreadyIn(product.Id)) {
            product = this.addDefaultValues(product);
        } else {
            return;
        }
        this.products = [product, ...this.products];
    }

    private addDefaultValues(product: any): any {
        product.Coefficent = 1;
        product.LowerIndex = 100;
        product.TopIndex = 100;
        return product;
    }

    private isAlreadyIn(id: any) {
        return !!this.products.find(prod => prod.Id === id);
    }

    public deleteSelected(id: number) {
        this.products = this.products.filter(prod => prod.Id !== id);
    }

    public closeModal(success: boolean) {
        this.dialogRef.close({close: success});
    }

    public save() {
        if (!this.checkIfEveryChecked()) {
            this.snackBar.info(
                'Uzupełnij wszystkie pola w zakładce: "Edycja wybranych SKU"'
            );
            return;
        }
        const form = this.creatingForm();
        this.startEdition = true;
        this.dataService.createProductLogicRelation(form)
            .pipe(finalize(() => this.startEdition = false))
            .subscribe(
                response => {
                    this.closeModal(true);
                },
                error => {
                    console.log(error);
                }
            );
    }

    private checkIfEveryChecked() {
        for (let product of this.products) {
            // TODO: add top & low index validation
            if (!product.TopIndex || !product.LowerIndex || !product.Coefficent || !product.RelationName) {
                return false;
            }
        }
        return true;
    }

    private creatingForm(): ProductLogicsCreatingForm {
        return {
            MainProductId: this.product.Id,
            DependentProductsList: this.products.map(product => {
                return {
                    Id: product.Id,
                    RelationName: product.RelationName,
                    Coefficent: product.Coefficent,
                    TopIndex: product.TopIndex,
                    LowerIndex: product.LowerIndex
                }
            })
        }
    }

}
